import RankingStat from '../../entities/RankingStat.js';
import PitchingRankingStats from '../../enums/PitchingRankingStats.js';
import NumberFormatter from '../../formatters/NumberFormatter.js';
import SelectiveRankingStatCalculatorBase from './SelectiveRankingStatCalculatorBase.js';

class InningsPitchedRankingStatCalculator extends SelectiveRankingStatCalculatorBase {
    constructor(numberFormatter) {
        if (typeof(numberFormatter) !== 'undefined' && !(numberFormatter instanceof NumberFormatter)) {
            throw new TypeError('numberFormatter must be an instance inheriting from NumberFormatter class');
        }
        super([
            PitchingRankingStats.InningsPitched
        ]);

        this.dependencies = [PitchingRankingStats.OutsPitched];
        this.numberFormatter = numberFormatter || new NumberFormatter(3);
    }

    listDependencies(parameter) {
        // TODO - maybe concat ?
        return this.dependencies;
    }

    calculateStat(parameter, dependencies) {
        const ip = dependencies[0].value / 3;
        return RankingStat.fromParameter(
            parameter, this.numberFormatter.format(ip), dependencies[0].value
        );
    }
}

export default InningsPitchedRankingStatCalculator;